// @ commons
const { formatText } = require('core/i18n').i18n;
const { EMPLOYMENT_SITUATION } = require('constants/mortgageRequestHolderData');
const DOCUMENTS_TYPES = require('constants/mortgageRequestDocumentsTypes');

const text = () => {
    return  {
        TITLE: formatText('mortgageRequestViewProcess-title'),
        SUBTITLE: formatText('mortgageRequestViewProcess-subTitle'),
        SECTION: {
            HOLDER_INFORMATION: {
                TITLE: formatText('mortgageRequestViewProcess-sectionHolderInfoTitle'),
                ITEM_PERSONAL_DATA: formatText('mortgageRequestViewProcess-sectionHolderInfoPersonalData'),
                ITEM_WORK_DATA: formatText('mortgageRequestViewProcess-sectionHolderInfoWorkData'),
                ITEM_ECONOMIC_DATA: formatText('mortgageRequestViewProcess-sectionHolderInfoEconomicData')
            },
            LIVING_PLACE: {
                TITLE: formatText('mortgageRequestViewProcess-sectionLivingPlaceTitle'),
                ITEM_ESTATES: formatText('mortgageRequestViewProcess-sectionLivingPlaceItemEstates'),
                ITEM_SIMPLE_NOTE: formatText('mortgageRequestViewProcess-sectionLivingPlaceItemSimpleNote'),
                ITEM_APPRAISAL: formatText('mortgageRequestViewProcess-sectionLivingPlaceItemAppraisal'),
            },
            RELATED_PRODUCTS: {
                TITLE: formatText('mortgageRequestViewProcess-sectionRelatedProductsTitle'),
                ITEM_INSURANCE_RELATED: formatText('mortgageRequestViewProcess-sectionRelatedProductsItemInsurance'),
            },
            SIGNATURE_PREPARATION: {
                TITLE: formatText('mortgageRequestViewProcess-sectionSignatureTitle'),
                ITEM_EXPENSES: formatText('mortgageRequestViewProcess-sectionSignatureItemExpensesProvision'),
                ITEM_PREPARATION: formatText('mortgageRequestViewProcess-sectionSignatureItemPreparation'),
                EXPENSES: 'EXPENSES',
                SIGNATURE: 'SIGNATURE'
            },
            MORTGAGE_INFO: {
                TITLE: formatText('mortgageRequestViewProcess-sectionMortgageInfoTitle'),
                AMOUNT: formatText('mortgageRequestViewProcess-sectionMortgageInfoAmount'),
                TERM: formatText('mortgageRequestViewProcess-sectionMortgageInfoTerm'),
                MONTHLY_FEE: formatText('mortgageRequestViewProcess-sectionMortgageInfoMonthlyFee'),
                TIN: formatText('mortgageRequestViewProcess-sectionMortgageInfoTIN'),
                TAE: formatText('mortgageRequestViewProcess-sectionMortgageInfoTAE'),
                TAE_INFO: formatText('mortgageRequestViewProcess-sectionMortgageInfoTAEExplanation')
            }
        }
    }
}

const EMPLOYMENT_SITUATION_INVALID = [
    EMPLOYMENT_SITUATION.RENTISTA_OTROS,
    EMPLOYMENT_SITUATION.SIN_ACTIVIDAD_ECONOMICA,
    EMPLOYMENT_SITUATION.PENSIONISTA,
    EMPLOYMENT_SITUATION.AUTONOMO,
    EMPLOYMENT_SITUATION.PARADO,
];

const LABORAL_LIFE_TYPE_LIST = [
    DOCUMENTS_TYPES.NOM_VL,
    DOCUMENTS_TYPES.VL,
    DOCUMENTS_TYPES.NOM
];

const IRPF100_TYPE_LIST = [
    DOCUMENTS_TYPES.IRPF100,
    DOCUMENTS_TYPES.IRPF100_CLI
];

const IRPF300_TYPE_LIST = [
    DOCUMENTS_TYPES.IRPF130
];

module.exports = {
    EMPLOYMENT_SITUATION_INVALID,
    LABORAL_LIFE_TYPE_LIST,
    IRPF100_TYPE_LIST,
    IRPF300_TYPE_LIST,
    text,
}
